import { cn } from "@/lib/utils";
import logo from "@/assets/swishr-central.png";
import logoWhite from "@/assets/swishr-central-white.png";

// Swishr Central logo (uploaded brand asset, white background made transparent).
export const Logo = ({ className, light = false }) => {
  return (
    <img
      src={light ? logoWhite : logo}
      alt="Swishr Central"
      data-testid="fgp-logo"
      className={cn("h-24 w-auto select-none object-contain", className)}
    />
  );
};
